import config from '@/plugins/global-config';

export function getTokenStorageKey(): string {
  try {
    const hostname = config.NEXT_URL ? new URL(config.NEXT_URL).hostname : window.location.hostname;
    const apihostname = config.API_BASE_URL ? '-' + new URL(config.API_BASE_URL).hostname : '';
    return `token-sey-${hostname}${apihostname}`;
  } catch (_error) {
    console.warn('Invalid NEXT_URL in config, fallback to window.location.hostname');
    return `sey-${window.location.hostname}-token`;
  }
}
